import React from 'react';
import './EnrollmentModal.css';

export default function EnrollmentModal({ isOpen, onClose, courseTitle }) {
  if (!isOpen) return null;

  return (
    <div className="em-modal-overlay" onClick={onClose}>
      <div className="em-modal-card" onClick={(e) => e.stopPropagation()}>
        {/* Ambient Glow */}
        <div className="em-modal-glow" />

        <div className="em-modal-content">
          {/* Animated Green Badge Icon */}
          <div className="em-success-icon-wrapper">
            <div className="em-success-pulse" />
            <div className="em-success-icon">✓</div>
          </div>

          <span className="em-modal-tag">Enrollment Confirmed</span>

          <h2 className="em-modal-title">Welcome Aboard!</h2>

          <p className="em-modal-course-name">
            Course: <strong>{courseTitle || 'Your Selected Program'}</strong>
          </p>

          <p className="em-modal-message">
            Thank you for choosing <strong>AV Tech</strong> to advance your skills! Your enrollment request has been successfully recorded. 
            <br /><br />
            Our technical support team will reach out to you shortly via <strong>Email</strong> or <strong>Phone Call</strong> with your onboarding schedule and next steps.
          </p>

          <div className="em-modal-actions">
            <button className="em-modal-btn-success" onClick={onClose}>
              Awesome, Got It!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}